import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'redux/store'

const selectAuthState = (state: RootState) => state.auth

export const selectAuthToken = createSelector(selectAuthState, (state) => state.accessToken)
export const selectCurrentUserTenantId = createSelector(selectAuthState, (state) => state.tenantId)
export const selectCurrentUserId = createSelector(selectAuthState, (state) => state.id)
